(function () {
  "use strict";

  var STATUS_CONTRACT_VERSION = "2.0.0";
  var ENROLLMENT_RECEIPT_KEY = "wynch_club_enrollment_receipt_v1";
  var CONTINUATION_KEY = "wynch_club_continuation_v1";
  var CONTINUATION_OWNER_KEY = "wynch_club_continuation_owner_v1";
  var LAST_STOREFRONT_KEY = "wynch_club_last_storefront_path_v1";
  var LAST_STOREFRONT_MAX_AGE_MS = 31 * 24 * 60 * 60 * 1000;

  function safePath(value) {
    if (typeof value !== "string" || !value || value.length > 2000 || value.charAt(0) !== "/" || value.slice(0, 2) === "//") return "";
    try {
      var target = new URL(value, window.location.origin);
      if (target.origin !== window.location.origin) return "";
      target.searchParams.delete("wynch_club");
      return target.pathname + target.search + target.hash;
    } catch (error) { return ""; }
  }

  function validTimestamp(createdAt, now) {
    return Number.isFinite(createdAt) && createdAt >= 0 && createdAt <= now + 60 * 1000;
  }

  function readEnrollmentReceipt(storage, now) {
    try {
      var value = JSON.parse(storage.getItem(ENROLLMENT_RECEIPT_KEY) || "null");
      if (!value || value.version !== "1.0.0" || typeof value.continuationToken !== "string" || !/^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value.continuationToken)) return null;
      var path = safePath(value.returnPath);
      if (!path || typeof value.source !== "string" || !validTimestamp(value.createdAt, now)) return null;
      var owner = storage.getItem(CONTINUATION_OWNER_KEY);
      if (value.owner && (value.owner !== owner || storage.getItem(CONTINUATION_KEY) !== value.continuationToken)) return null;
      if (!value.owner && owner && storage.getItem(CONTINUATION_KEY) !== value.continuationToken) return null;
      return { continuationToken: value.continuationToken, returnPath: path };
    } catch (error) { return null; }
  }

  function readLegacyReceipt(runtime, storage, now) {
    if (!runtime) return null;
    var value = runtime.readPendingReceipt(storage, now);
    if (!value) return null;
    return { continuationToken: value.sessionId, returnPath: safePath(value.returnPath), legacy: value };
  }

  function readLastStorefrontPath(storage, now) {
    try {
      var value = JSON.parse(storage.getItem(LAST_STOREFRONT_KEY) || "null");
      if (!value || value.version !== "1.0.0" || !validTimestamp(value.updatedAt, now) || now - value.updatedAt > LAST_STOREFRONT_MAX_AGE_MS) return "";
      return safePath(value.path);
    } catch (error) { return ""; }
  }

  function confirmedDestination(receipt, storage, now) {
    var path = receipt.returnPath || readLastStorefrontPath(storage, now);
    var target = new URL(path, window.location.origin);
    target.searchParams.set("wynch_club", "confirmed");
    return target.toString();
  }

  function reminderReturnPath() {
    try {
      return safePath(new URL(window.location.href).searchParams.get("wynch_reminder_path"));
    } catch (error) { return ""; }
  }

  function statusRequest(receipt, locale) {
    return window.fetch("/apps/wynch-email/status", {
      method: "POST",
      headers: { "accept": "application/json", "content-type": "application/json" },
      credentials: "same-origin",
      cache: "no-store",
      body: JSON.stringify({
        contract_version: STATUS_CONTRACT_VERSION,
        continuation_token: receipt.continuationToken,
        locale: locale
      })
    }).then(function (response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        if (!response.ok) throw new Error(body.error || "WYNCH_DOI_STATUS_FAILED_V1");
        if (body.contract_version !== STATUS_CONTRACT_VERSION || ["pending", "confirmed"].indexOf(body.state) === -1) throw new Error("WYNCH_DOI_STATUS_INVALID_V1");
        return body;
      });
    });
  }

  function initialize(node) {
    if (!node) return;
    var callbackUrl = new URL(window.location.href || window.location.origin);
    var personalClaim = new URLSearchParams(callbackUrl.hash.slice(1)).get("wynch_claim");
    var sharedUi = null;
    try { sharedUi = JSON.parse(window.localStorage.getItem("wynch_article_club_confirmed_ui_v1") || "null"); } catch (error) {}
    // Native DOI now hands off to the shared Claim UI, not an automatic cart
    // operation. Mirror that UI here instead of leaving an unowned 0% loader.
    // The shared event also covers a bare callback refresh and either load order.
    if (!personalClaim && callbackUrl.searchParams.get("wynch_bonus") !== "claim" && /\/pages\/wynch-club-confirmed\/?$/.test(callbackUrl.pathname) &&
      (["return", "confirmed"].indexOf(callbackUrl.searchParams.get("wynch_club")) !== -1 || sharedUi && (sharedUi.state === "confirmed" || sharedUi.state === "claimed" || sharedUi.confirmedAt))) {
      var sharedGerman = (node.dataset.locale || "").toLowerCase() === "de";
      var claimed = sharedUi && sharedUi.state === "claimed";
      var sharedHeading = node.querySelector("h1");
      var sharedProgress = node.querySelector("[data-doi-progress]");
      var sharedStatus = node.querySelector("[data-doi-callback-status]");
      var sharedFallback = node.querySelector("[data-doi-callback-fallback]");
      var sharedLink = sharedFallback && sharedFallback.querySelector("a");
      if (sharedHeading) sharedHeading.textContent = claimed
        ? (sharedGerman ? "Deine Geschenke sind im Warenkorb" : "Your gifts are in your cart")
        : (sharedGerman ? "Deine E-Mail ist bestätigt" : "Your email is confirmed");
      if (sharedStatus) sharedStatus.textContent = claimed
        ? (sharedGerman ? "Freu dich auf deine Cava und 30 % Rabatt auf deine erste Bestellung." : "Enjoy your Cava on us and 30% off your first order.")
        : (sharedGerman ? "Deine Cava und 30 % Rabatt warten auf dich. Öffne deine Willkommensgeschenke, um sie in den Warenkorb zu legen." : "Your complimentary Cava and 30% discount are ready. Open your welcome gifts to add them to your cart.");
      if (sharedProgress) sharedProgress.hidden = true;
      node.setAttribute("aria-busy", "false");
      if (sharedLink) {
        var sharedDestination = new URL(window.WynchRedirectBenefitsV1 ? window.WynchRedirectBenefitsV1.returnPath() : (sharedGerman ? "/pages/quiz" : "/en/pages/quiz"), window.location.origin);
        sharedDestination.searchParams.set("wynch_club", "confirmed");
        sharedLink.href = sharedDestination.pathname + sharedDestination.search + sharedDestination.hash;
        sharedLink.hidden = false;
        sharedLink.textContent = sharedGerman ? "Willkommensgeschenke ansehen" : "View my welcome gifts";
        if (node.dataset.doiSharedActionReady !== "true") {
          node.dataset.doiSharedActionReady = "true";
          sharedLink.addEventListener("click", function (event) {
            if (!window.WynchClubFlowV1) return;
            event.preventDefault();
            window.WynchClubFlowV1.renderState(null, true, true);
          });
        }
      }
      if (sharedFallback) sharedFallback.hidden = false;
      node.dataset.doiCallbackReady = "true";
      return;
    }
    if (node.dataset.doiCallbackReady === "true") return;
    if (window.WynchRedirectBenefitsV1 && window.WynchRedirectBenefitsV1.isActive()) return;
    // Welcome links are handled by the global bonus-claim adapter, not the DOI return poller.
    if (new URL(window.location.href || window.location.origin).searchParams.get("wynch_bonus") === "claim") {
      node.dataset.doiCallbackReady = "true";
      var bonusGerman = (node.dataset.locale || "").toLowerCase() === "de";
      var bonusHeading = node.querySelector("h1");
      var bonusProgress = node.querySelector("[data-doi-progress]");
      var bonusStatus = node.querySelector("[data-doi-callback-status]");
      var bonusFallback = node.querySelector("[data-doi-callback-fallback]");
      var bonusLink = bonusFallback && bonusFallback.querySelector("a");
      if (bonusHeading) bonusHeading.textContent = bonusGerman ? "Deine Vorteile" : "Your benefits";
      if (bonusProgress) bonusProgress.hidden = true;
      if (bonusStatus) bonusStatus.textContent = bonusGerman
        ? "Wir prüfen deine bestätigte Anmeldung und bereiten Cava und Rabatt vor."
        : "We’re checking your confirmed subscription and preparing your Cava and discount.";
      if (bonusLink) {
        bonusLink.href = readLastStorefrontPath(window.localStorage, Date.now()) || "/";
        bonusLink.textContent = bonusGerman ? "Zurück zu WYNCH" : "Back to WYNCH";
      }
      if (bonusFallback) bonusFallback.hidden = false;
      return;
    }
    node.dataset.doiCallbackReady = "true";
    var runtime = window.WynchArticleClubDoiReturnV1;
    var status = node.querySelector("[data-doi-callback-status]");
    var fallback = node.querySelector("[data-doi-callback-fallback]");
    var fallbackLink = fallback && typeof fallback.querySelector === "function" ? fallback.querySelector("a") : null;
    var isGerman = (node.dataset.locale || "").toLowerCase() === "de";
    var progress = node.querySelector("[data-doi-progress]");
    var bar = node.querySelector("[data-doi-progress-bar]");
    var fill = node.querySelector("[data-doi-progress-fill]");
    var number = node.querySelector("[data-doi-progress-number]");
    var frame = 0;
    var started = Date.now();
    function paint(value) {
      if (!bar || typeof bar.setAttribute !== "function") return;
      bar.setAttribute("aria-valuenow", String(value));
      fill.style.width = value + "%";
      number.textContent = value + "%";
    }
    function stopProgress(completed) {
      if (frame) window.cancelAnimationFrame(frame);
      frame = 0;
      if (completed) paint(100);
      else if (progress) progress.hidden = true;
    }
    function animate() {
      paint(Math.min(95, Math.floor(95 * (1 - Math.exp(-(Date.now() - started) / 6000)))));
      frame = window.requestAnimationFrame(animate);
    }
    if (bar && typeof bar.setAttribute === "function" && window.requestAnimationFrame) {
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) paint(0);
      else frame = window.requestAnimationFrame(animate);
      window.addEventListener("pagehide", function () { stopProgress(false); }, { once: true });
    }
    var now = Date.now();
    var reminderPath = reminderReturnPath();
    if (reminderPath) {
      window.location.replace(confirmedDestination({ returnPath: reminderPath }, window.localStorage, now));
      return;
    }
    var receipt = readEnrollmentReceipt(window.localStorage, now) || readLegacyReceipt(runtime, window.localStorage, now);

    function revealFallback(message) {
      stopProgress(false);
      status.textContent = message;
      if (fallbackLink && receipt) fallbackLink.href = readLastStorefrontPath(window.localStorage, Date.now()) || receipt.returnPath;
      if (fallbackLink && receipt) fallbackLink.textContent = isGerman ? "Zurück zu WYNCH" : "Back to WYNCH";
      if (fallback) fallback.hidden = false;
    }

    if (!receipt) {
      var heading = node.querySelector("h1");
      if (heading) heading.textContent = isGerman ? "DEIN PERSÖNLICHER LINK" : "YOUR PERSONAL LINK";
      var lastPath = readLastStorefrontPath(window.localStorage, now);
      if (fallbackLink && lastPath) {
        fallbackLink.href = lastPath;
        fallbackLink.textContent = isGerman ? "Zur letzten Seite (ohne Vorteile)" : "Last page (without gifts)";
      } else if (fallbackLink) {
        fallbackLink.hidden = true;
      }
      revealFallback(isGerman
        ? "Dieser Klaviyo-Link übermittelt deine Identität nicht erneut. Öffne die persönliche WYNCH E-Mail mit deinen Vorteilen, um Cava und Rabatt ohne Anmeldung wiederherzustellen."
        : "This Klaviyo link does not pass your identity on a repeat visit. Open your personal WYNCH benefits email to restore Cava and your discount without signing in.");
      return;
    }

    status.textContent = isGerman
      ? "Bestätigung wird geprüft. Danach aktivieren wir Cava und WELCOME30 …"
      : "Checking your confirmation. Then we’ll activate Cava and WELCOME30 …";

    function poll(attempts) {
      statusRequest(receipt, isGerman ? "de" : "en").then(function (result) {
        if (result.state === "confirmed") {
          stopProgress(true);
          status.textContent = isGerman
            ? "Bestätigt. Cava und WELCOME30 werden auf deiner letzten Seite aktiviert …"
            : "Confirmed. Cava and WELCOME30 will be activated on your last page …";
          try { window.localStorage.removeItem(ENROLLMENT_RECEIPT_KEY); } catch (error) {}
          if (runtime && receipt.legacy) try { runtime.clearPendingReceipt(window.localStorage); } catch (error) {}
          document.dispatchEvent(new CustomEvent("wynch:club-confirmed"));
          var destination = confirmedDestination(receipt, window.localStorage, Date.now());
          window.location.replace(destination);
          return;
        }
        revealFallback(isGerman
          ? "Deine E-Mail ist noch nicht bestätigt. Bestätige sie zuerst; wir prüfen im Hintergrund weiter."
          : "Your email is not confirmed yet. Confirm it first; we’ll keep checking in the background.");
        if (attempts > 0) {
          window.setTimeout(function () { poll(attempts - 1); }, 1500);
          return;
        }
      }).catch(function () {
        revealFallback(isGerman
          ? "Die Bestätigung konnte gerade nicht geprüft werden. Kehre zur letzten Seite zurück."
          : "We could not check your confirmation right now. Return to your last page.");
        if (attempts > 0) {
          window.setTimeout(function () { poll(attempts - 1); }, 1500);
          return;
        }
      });
    }

    poll(20);
  }

  function initializeAll() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-wynch-club-doi-callback]"), initialize);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initializeAll, { once: true });
  else initializeAll();
  document.addEventListener("shopify:section:load", initializeAll);
  window.addEventListener("wynch:club-enrollment-registered", initializeAll);
}());
